<section class="page">
  <div class="page__content">
    <div class="page__text">
      <h1 class="page__title">
        <span
          class="page__title-accent"
          [innerHTML]="'workflowFsePlus.title' | translate"
        ></span>
        <span
          class="page__title-main"
          [innerHTML]="'workflowFsePlus.subtitle' | translate"
        ></span>
      </h1>
      <p class="page__description">
        {{ 'workflowFsePlus.description' | translate }}
      </p>
      <button
        kendoButton
        themeColor="primary"
        size="large"
        class="page__action"
        maximizerShowcaseBookDemo
      >
        {{ 'workflowFsePlus.button.action' | translate }}
      </button>
    </div>
    <div class="page__media">
      <img
        [src]="cdn + '/assets/images/showcase/workflow.svg'"
        [alt]="'workflowFsePlus.image.alt' | translate"
        class="page__image"
      />
    </div>
  </div>
</section>
